import Phaser from 'phaser';

export class GameOverScene extends Phaser.Scene {
  private level = 1;

  constructor() {
    super('GameOverScene');
  }

  init(data: { level?: number }): void {
    this.level = data.level ?? 1;
  }

  create(): void {
    const W = this.scale.width;
    const H = this.scale.height;
    this.add.rectangle(0, 0, W, H, 0x1d1010).setOrigin(0, 0);

    this.add
      .text(W / 2, H / 2 - 100, 'GAME OVER', {
        fontFamily: 'sans-serif',
        fontSize: '64px',
        color: '#ff8c8c',
      })
      .setOrigin(0.5);
    this.add
      .text(W / 2, H / 2 - 30, `You fell on level ${this.level}.`, {
        fontFamily: 'sans-serif',
        fontSize: '24px',
        color: '#ffffff',
      })
      .setOrigin(0.5);

    this.makeButton(W / 2 - 130, H / 2 + 80, 'Retry', () => {
      this.scene.start('LevelIntroScene', { level: this.level });
    });
    this.makeButton(W / 2 + 130, H / 2 + 80, 'Exit to menu', () => {
      this.scene.start('TitleScene');
    });
  }

  private makeButton(x: number, y: number, label: string, onClick: () => void): void {
    const c = this.add.container(x, y);
    const bg = this.add.rectangle(0, 0, 200, 50, 0x3d2914).setStrokeStyle(2, 0xffffff);
    const t = this.add
      .text(0, 0, label, { fontFamily: 'sans-serif', fontSize: '22px', color: '#fff' })
      .setOrigin(0.5);
    c.add([bg, t]);
    c.setSize(200, 50).setInteractive({ useHandCursor: true });
    c.on('pointerover', () => bg.setFillStyle(0x6b3410));
    c.on('pointerout', () => bg.setFillStyle(0x3d2914));
    c.on('pointerdown', onClick);
  }
}
